import {
    GET_OTS_DASHBOARD_REQUEST,
    GET_OTS_DASHBOARD_SUCCESS,
    GET_OTS_DASHBOARD_ERROR
} from "./types";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";

const axios = require("axios");
export const getOtsDashboard = (token, data, seasonID, statusID, PCID, BgradeCheck) => (dispatch) => {

    dispatch({ type: GET_OTS_DASHBOARD_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/Otsdashboard`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: {
            product_status_id: statusID.length > 0 ? statusID.toString() : null,
            new_season_id : data.season_id === "All" ? null : data.season_id,
            gender_id: data.gender_id === "All" ? null : data.gender_id,
            from_date: moment(data.from_date).format("YYYY-MM-DD"),
            to_date: moment(data.to_date).format("YYYY-MM-DD"),
            product_class_id: null,
            category_id: null,
            fit_category_id: null,
            style_id: null,
            product_class_id: null,
            sort_on: null,
            include_bgrade: null,
            wash_id: null
        }
    })
        .then((response) => {
            return dispatch({ type: GET_OTS_DASHBOARD_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            if (error.response.data.data === "No Record Found !") {
                return dispatch({
                    type: GET_OTS_DASHBOARD_ERROR,
                    payload: [],
                });
            }
            return dispatch({
                type: GET_OTS_DASHBOARD_ERROR,
                payload: error.response,
            });
        });
};
